import { render, staticRenderFns } from "./OurPlaces.vue?vue&type=template&id=131186f3&"
import script from "./OurPlaces.vue?vue&type=script&lang=js&"
export * from "./OurPlaces.vue?vue&type=script&lang=js&"
import style0 from "./OurPlaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports